/** KAN-826: server 400 messages under a section of the upload form. */
export function SectionErrors({
  testId,
  errors,
}: {
  testId: string;
  errors: string[];
}): JSX.Element | null {
  if (errors.length === 0) return null;
  return (
    <ul data-testid={testId} className="space-y-1 text-xs text-red-600">
      {errors.map((message) => (
        <li key={message}>{message}</li>
      ))}
    </ul>
  );
}
